<template>
    <div class="items_list" v-if="items.length !== 0">
        <item
            v-for="item in items"
            :key="item.id"
            :item="item"
            :itemType="item.card !== undefined ? 'contract' : 'service'"
        />
    </div>
    <div class="items_list items_list--empty" v-if="items.length === 0">
        <i>
            <img src="../assets/img/kek.png">
        </i>
        <p>{{ emptyText }}</p>
    </div>
</template>

<script>
    import Item from '../components/Item'

    export default {
        name: "ItemsList",
        components: { Item },
        props: {
            items: {
                type: Array,
                default: () => []
            },
            itemsType: {
                type: String,
                default: () => 'mixed'
            },
        },
        computed: {
            emptyText: function () {
                if (this.itemsType === 'contracts'){
                    return 'У вас нет действующих абонементов'
                }else if (this.itemsType === 'services'){
                    return 'У вас нет действующих услуг'
                }else{
                    return 'Ничего не найдено'
                }
            }
        }
    }
</script>